const tableTitlePlaces = {
  title: 'Locais',
  placeholder: 'Pesquisar'
};

export default tableTitlePlaces;
